import React, { type PropsWithChildren } from "react";

import * as styles from "@/features/betslip/components/cards/BetCard.module.scss";

type BetCardProps = PropsWithChildren<{
  testId?: string;
  alert?: React.ReactNode;
  banner?: React.ReactNode;
}>;

export const BetCard = ({ testId, alert, banner, children }: BetCardProps) => (
  <div className={styles.root}>
    {alert}
    {banner}
    <div className={styles.card} data-testid={testId}>
      <div className={styles.body}>{children}</div>
    </div>
  </div>
);
